

    <div>
        <mat-toolbar>
            <mat-toolbar-row class="bg-secondary-container flex justify-end gap-4">

                @if ((config().invalidFields?.length ?? 0) > 0) {
                    <div class="text-error flex w-full items-center gap-2 text-base">
                        <span class="hidden sm:inline" [matTooltip]="invalidFieldsTooltip()">to save, please resolve form errors</span>
                    </div>
                }


                <div class="flex gap-2">

                    @if (config().cancel?.show) {
                    <button matButton="elevated" type="button" [disabled]="!config().cancel?.enable" (click)="onAction('cancel')">
                        <mat-icon>cancel</mat-icon>Cancel
                    </button>
                    }

                    @if (config().save?.show) {
                    <button matButton="elevated" color="primary" type="button"
                            [disabled]="!config().save?.enable" (click)="onAction('save')"
                            [attr.test-id]="'button-save'">
                        <mat-icon>save</mat-icon>Save
                    </button>
                    }

                    @if (config().back?.show) {
                    <button matButton="elevated" type="button" [disabled]="!config().back?.enable" (click)="onAction('back')">
                        <mat-icon>arrow_back</mat-icon>Back
                    </button>
                    }

                    @if (config().ok?.show) {
                    <button matButton="elevated" type="button" color="primary" [disabled]="!config().ok?.enable" (click)="onAction('ok')">
                        <mat-icon>check</mat-icon>Ok
                    </button>}

                    <ng-content></ng-content>

                </div>

            </mat-toolbar-row>

        </mat-toolbar>
    </div>
